<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex xs12 sm2>
                    <v-text-field
                        v-model="client.Title"
                        label="Title"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm5>
                    <v-text-field
                        v-model="client.FirstName"
                        label="First name"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm5>
                    <v-text-field
                        v-model="client.LastName"
                        label="Last name"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                    <v-text-field
                        v-model="client.Email1"
                        label="Email"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                    <v-text-field
                        v-model="client.CellNumber1"
                        label="Contact number"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex xs12>
                    <v-text-field
                        v-model="client.IdentityNumber"
                        label="ID Number"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                    <v-text-field
                        :value="client.DateOfBirth ? client.DateOfBirth.substring(0, 10) : ''"
                        label="Birth date"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                    <v-text-field
                        v-model="client.Gender"
                        label="Gender"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                client: {},
            }
        },
        props: ['itemInfo'],
        name: 'Quotation-Info',
        mounted() {
            this.client = this.itemInfo;

            setTimeout(() => {
                this.loading = false;
            }, 100);
        },
    }
</script>
